'use strict';

import Platform from './core/platform';

import './entity/options';
import './core/trait';

import './core/helper';

import './entity/entity';
import './entity/events-core';
import './entity/events';
import './entity/entity-proxy';
import './entity/entity-array';
import './entity/entity-set';

import './core/widget';

import './dom/dom';
import './dom/dom-node';
import './dom/dom-list';
import './dom/observer';

import './service/locale';
import './service/util';
import './service/speech';

import './f7-ext/app';
import './f7-ext/page';
import './f7-ext/dynamic-page';


import './data/model';
import './data/models';
import './data/file';
import './data/filter';

import './components/button/button-submit';
import './components/form/form';

import './components/list/list';
import './components/list/list-crud';
import './components/list/traits/add';
import './components/list/traits/search';
import './components/list/traits/select';
import './components/list/traits/delete';
import './components/list/traits/item-select';
import './components/list/traits/item-edit';
import './components/list/traits/item-dnd';

import './components/list/list-crud-page';
import './components/list/traits/item-edit-page';
import './components/list/traits/add-page';

import './components/map/points-list';
import './components/map/polygon-list';
import './components/map/polygon';
import './components/map/polyline';

import './components/charts/highcharts';
import './components/charts/pie';

import './components/slider/slider';

import './components/file/file-input';
import './components/file/file-list';
import './components/file/file-one';
import './components/file/file-item';
import './components/file/img-item';
import './components/file/doc-item';

import './components/popup/f7popup';
import './components/popup/popup';
import './components/popup/tooltip';

import './components/preloader/preloader';

import './components/bottom-panel/bottom-panel';


import './components/calendar/calendar';
import './service/locale';

import './components/fields/field';
import './components/fields/string/string';
import './components/fields/string/int';
import './components/fields/string/float';
import './components/fields/string/phone';
import './components/fields/string/ip';
import './components/fields/date/date';
import './components/fields/date/date-diapason';
import './components/fields/radio/radio-group';
import './components/fields/button-toggle/button-toggle';
import './components/fields/select/select';
import './components/fields/select/multi-select';
import './components/fields/select/tree-select';
import './components/fields/select/tree-multi-select';
import './components/fields/check/check-box';
import './components/fields/check/check-group';
import './components/fields/map/map-point';
import './components/fields/map/map-polyline';
import './components/fields/list/list';
import './components/fields/list/list-crud';
import './components/fields/file/file-list';
import './components/fields/file/file-one';
import './components/fields/slider/slider';

import './components/floating-picker/floating-picker';
import './f7-ext/right-panel';

export { Platform };